import { useState, useCallback, useEffect } from 'react'

const synth = () => (typeof window !== 'undefined' ? window.speechSynthesis ?? null : null)

/** Markdown and chat decoration → plain sentences a voice can read. */
export function speakable(text) {
  return String(text ?? '')
    .replace(/```[\s\S]*?```/g, '')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/[*_`#>~|]/g, '')
    .replace(/^\s*[-•]\s+/gm, '')
    .replace(/(\d)\s*°C/g, '$1 Grad')
    .replace(/(\d)\s*kWh\b/g, '$1 Kilowattstunden')
    .replace(/(\d)\s*kW\b/g, '$1 Kilowatt')
    .replace(/(\d)\s*W\b/g, '$1 Watt')
    .replace(/(\d)\s*%/g, '$1 Prozent')
    .replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/gu, '')
    .replace(/\s+/g, ' ')
    .trim()
}

function germanVoice() {
  const voices = synth()?.getVoices() ?? []
  const de = voices.filter(v => v.lang?.toLowerCase().startsWith('de'))
  return de.find(v => /premium|enhanced|natural|google/i.test(v.name)) ?? de.find(v => v.localService) ?? de[0] ?? null
}

/** Read answers aloud (speechSynthesis, German voice when the device has one). */
export function useSpeech() {
  const [speaking, setSpeaking] = useState(false)
  const supported = !!synth()

  const cancel = useCallback(() => {
    synth()?.cancel()
    setSpeaking(false)
  }, [])

  const speak = useCallback((text, { onEnd } = {}) => {
    const s = synth()
    const words = speakable(text)
    if (!s || !words) { onEnd?.(); return }
    s.cancel()
    const u = new SpeechSynthesisUtterance(words)
    u.lang = 'de-DE'
    const voice = germanVoice()
    if (voice) u.voice = voice
    u.rate = 1.05
    u.onstart = () => setSpeaking(true)
    u.onend = () => { setSpeaking(false); onEnd?.() }
    u.onerror = () => setSpeaking(false)
    s.speak(u)
  }, [])

  useEffect(() => () => synth()?.cancel(), [])

  return { speaking, speak, cancel, supported }
}
